import core from './commuCore'
const output = {}

function getSyncData (data) {
  return core.ajax(data, '/export/getSyncData', 'get')
}
output.getSyncData = getSyncData

function syncData () {
  return core.ajax(null, '/export', 'post')
}
output.syncData = syncData

function makeSyncCache (data) {
  return core.ajax(data, '/export/makeSyncCache', 'get')
}
output.makeSyncCache = makeSyncCache

function getAbnormalData (data) {
  return core.ajax(data, '/export/comparison', 'get')
}
output.getAbnormalData = getAbnormalData

function fixData (data) {
  return core.ajax(data, '/export/fixData', 'post')
}
output.fixData = fixData

function syncCount (data) {
  return core.ajax(data, '/export/syncCount', 'get')
}
output.syncCount = syncCount

function getTaskSyncData (data) {
  return core.ajax(data, '/export/task/getSyncData', 'get')
}
output.getTaskSyncData = getTaskSyncData

function syncTaskData (data) {
  return core.ajax(data, '/export/task', 'post')
}
output.syncTaskData = syncTaskData

export default output
